module.exports = __webpack_public_path__ + "img/capsule-toy-pink.6a27fdd1.png";